import * as React from 'react'
import { motion } from 'framer-motion'
import { Box, SxProps } from '@mui/material'
import { useAnimationStyles } from 'src/Libs/live-view'
import EnergyFlowIndicatorSvg from './EnergyFlowIndicatorSvg'

export interface ArrowSvgProps {
  transform: string
  direction?: 'in' | 'out'
  doRotateBy180Deg?: boolean
  sx?: SxProps
}

const CurvedSideArrowSvg: React.FC<ArrowSvgProps> = ({ direction, transform, doRotateBy180Deg = false, sx }) => {
  const { classes, cx } = useAnimationStyles({ direction })

  return (
    <Box sx={{ position: 'relative', transform, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="130" height="145" viewBox="0 0 130 145" fill="none">
        <g id="livevalue_arrows">
          <motion.g id="line">
            <motion.path
              id="Vector 8"
              d="M127.5 7.49548H105C96.7157 7.49548 90 14.2112 90 22.4955V121.995C90 130.28 83.2843 136.995 75 136.995H1.5"
              stroke="#A4AAAE"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </motion.g>
          {direction === 'in' && (
            <g id="arrow_in_curved_side_arrow">
              <path
                d="M6.79177 129.788L6.86704 129.72C7.25982 129.4 7.8398 129.422 8.20599 129.788C8.57217 130.155 8.59488 130.735 8.27435 131.127L8.20599 131.203L1.70737 137.701C1.31685 138.092 0.683681 138.092 0.293156 137.701C-0.0973676 137.311 -0.0973676 136.678 0.293156 136.287L6.79177 129.788Z"
                fill="#A4AAAE"
              />
              <path
                d="M8.20722 142.789L8.27627 142.865C8.59645 143.258 8.57327 143.837 8.20722 144.203C7.81669 144.594 7.18353 144.594 6.793 144.203L0.293007 137.703C-0.0975174 137.313 -0.0975183 136.68 0.293006 136.289C0.68353 135.899 1.31669 135.899 1.70722 136.289L8.20722 142.789Z"
                fill="#A4AAAE"
              />
            </g>
          )}
          {direction === 'out' && (
            <g id="arrow_out_curved_side_arrow">
              <path
                d="M122.708 14.7079L122.633 14.7763C122.24 15.0968 121.66 15.0741 121.294 14.7079C120.928 14.3417 120.905 13.7617 121.226 13.369L121.294 13.2937L127.793 6.79507C128.183 6.40455 128.817 6.40455 129.207 6.79507C129.598 7.18559 129.598 7.81876 129.207 8.20928L122.708 14.7079Z"
                fill="#A4AAAE"
              />
              <path
                d="M121.293 1.70718L121.224 1.63123C120.904 1.23845 120.927 0.659025 121.293 0.292971C121.684 -0.0975533 122.317 -0.0975533 122.707 0.292971L129.207 6.79297C129.598 7.18349 129.598 7.81665 129.207 8.20718C128.817 8.5977 128.184 8.5977 127.793 8.20718L121.293 1.70718Z"
                fill="#A4AAAE"
              />
            </g>
          )}
        </g>
      </svg>
      {!!direction && (
        <EnergyFlowIndicatorSvg
          className={cx(classes.directionIndicator, classes.curvedSideArrowAnimation)}
          doRotateBy180Deg={doRotateBy180Deg}
          direction={direction}
        />
      )}
    </Box>
  )
}

export default CurvedSideArrowSvg
